import React from 'react';
import { TableCell, TableRow, FormControlLabel, Checkbox, Tooltip, IconButton, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Autocomplete, TextField } from '@totalsoft/rocket-ui';
import { Delete } from '@mui/icons-material';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const DocumentTemplateSignatureBookmarkListItemComponent = ({
  signatureBookmark,
  index,
  validation,
  onDelete,
  onPropertyChanged,
  onLookupPropertyChanged,
  signatureActors
}) => {
  const { t } = useTranslation();

  return (
    <TableRow>
      <TableCell>
        <TextField
          fullWidth
          value={signatureBookmark.name || ''}
          error={!isValid(validation[index].name)}
          helperText={getErrors(validation[index].name)}
          onChange={event => onPropertyChanged('name', event)}
        />
      </TableCell>
      <TableCell>
        <FormControlLabel
          control={
            <Checkbox
              checked={signatureBookmark.isTable}
              color='primary'
              onChange={event => onPropertyChanged('isTable', event.target.checked)}
            />
          }
        />
      </TableCell>
      <TableCell>
        <Autocomplete
          fullWidth
          value={signatureBookmark.signatureBookmarkActors?.map(item => {
            return item?.actorId;
          })}
          options={signatureActors}
          onChange={onLookupPropertyChanged}
          labelKey={'actorName'}
          valueKey={'actorId'}
          isMultiSelection={true}
          simpleValue={true}
          isClearable={true}
          isSearchable={true}
          error={!isValid(validation[index].signatureBookmarkActors)}
          helperText={getErrors(validation[index].signatureBookmarkActors)}
        />
      </TableCell>
      <TableCell>
        {signatureBookmark.generatedBookmarks &&
          signatureBookmark.generatedBookmarks.map((item, idx) => {
            return <Chip color='primary' size='small' key={idx} label={item} />;
          })}
      </TableCell>
      <TableCell>
        <Tooltip title={t('Tooltips.Delete')}>
          <IconButton color='primary' onClick={onDelete}>
            <Delete />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

DocumentTemplateSignatureBookmarkListItemComponent.propTypes = {
  index: PropTypes.number.isRequired,
  validation: PropTypes.object,
  onDelete: PropTypes.func.isRequired,
  signatureActors: PropTypes.array.isRequired,
  signatureBookmark: PropTypes.object.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  onLookupPropertyChanged: PropTypes.func.isRequired
};

export default DocumentTemplateSignatureBookmarkListItemComponent;
